import type { z } from 'zod';
import type { Tag } from '#dn-types/tag.ts';
import { mapFirewallRulesToRoleForm } from '#screens/roles/detail/form/mapFirewallRulesToRoleForm.ts';
import { splitOverrides } from '../hooks/split-overrides.ts';
import type { tagFormSchema } from './tag-form-schema.ts';

/** Maps an API {@link Tag} to TagForm default values.  Shared by the edit and duplicate screens. */
export function mapTagToForm(tag: Tag): z.input<typeof tagFormSchema> {
  return {
    name: tag.name,
    description: tag.description,
    configOverrides: splitOverrides(tag.configOverrides),
    routeSubscriptions: tag.routeSubscriptions.map((routeId) => ({ routeId })),
    firewallRules: mapFirewallRulesToRoleForm(tag.firewallRules ?? []),
  };
}
